import { GroupableView } from '../core/containers/container';
import { DiagramEvent, RealAction, DiagramConstraints } from '../enum/enum';
import { cloneObject as clone } from '../utility/base-util';
import { cloneBlazorObject } from '../utility/diagram-util';
/**
 * Layout Animation function to enable or disable layout animation
 */
export class LayoutAnimation {
    constructor() {
        this.protectChange = false;
        this.setIntervalObject = [];
    }
    /**
     * Layout expand function for animation of expand and collapse \
     *
     * @returns {  void }   Layout expand function for animation of expand and collapse .\
     * @param {boolean} animation - provide the angle value.
     * @param {ILayout} objects - provide the angle value.
     * @param {Node} node - provide the angle value.
     * @param {Diagram} diagram - provide the angle value.
     * @private
     */
    expand(animation, objects, node, diagram) {
        const setIntervalObject = {};
        const i = 0;
        let j = 0;
        diagram.realActions = diagram.realActions | RealAction.AnimationClick;
        this.setIntervalObject[parseInt(i.toString(), 10)] = setInterval(() => {
            j++;
            return this.layoutAnimation(objects, this.setIntervalObject, j === 6, diagram, node);
        }, 20);
        if (node.isExpanded) {
            let opacity = .2;
            diagram.protectPropertyChange(false);
            //let objects: ILayout = diagram.doLayout();
            const setIntervalObjects = {};
            const x = 0;
            if (animation) {
                this.updateOpacity(node, opacity, diagram);
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                const current = this;
                setIntervalObjects[parseInt(x.toString(), 10)] = setInterval(() => {
                    diagram.allowServerDataBinding = false;
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    opacity <= 1 ? this.updateOpacity(node, opacity, diagram) : clearInterval(setIntervalObjects[0]);
                    opacity += .2;
                    diagram.allowServerDataBinding = true;
                }, 20);
            }
        }
    }
    // Bug 877226: Nodes overlapped while changing isExpanded property with Layout Animation.
    // To stop the and clear the existing setinterval object
    // Added this to stop the existing setinterval object when the layout animation is called for multiple nodes.
    stopCurrentAnimation(objValue, diagram, node) {
        clearInterval(this.setIntervalObject[0]);
        this.setIntervalObject = [];
        for (let k = 0; k < objValue.objects.length; k++) {
            const node1 = diagram.nameTable[objValue.objects[parseInt(k.toString(), 10)].id];
            node1.offsetX += objValue.objects[parseInt(k.toString(), 10)].differenceX
                - (objValue.objects[parseInt(k.toString(), 10)].differenceX / 5);
            node1.offsetY += objValue.objects[parseInt(k.toString(), 10)].differenceY
                - (objValue.objects[parseInt(k.toString(), 10)].differenceY / 5);
        }
        diagram.realActions = diagram.realActions & RealAction.AnimationClick;
        diagram.refreshCanvasLayers();
        diagram.protectPropertyChange(true);
        diagram.triggerEvent(DiagramEvent.animationComplete, undefined);
        diagram.layout.fixedNode = '';
        diagram.protectPropertyChange(this.protectChange);
        const arg = {
            element: cloneBlazorObject(clone(node)), state: (node.isExpanded) ? true : false
        };
        diagram.triggerEvent(DiagramEvent.expandStateChange, arg);
        if (diagram.lineRoutingModule && diagram.constraints & DiagramConstraints.LineRouting) {
            diagram.resetSegments();
        }
    }
    /**
     * Setinterval and Clear interval for layout animation \
     *
     * @returns {  void }   Setinterval and Clear interval for layout animation .\
     * @param {ILayout} objValue - provide the angle value.
     * @param {Object} layoutTimer - provide the angle value.
     * @param {ILayout} stop - provide the angle value.
     * @param {Diagram} diagram - provide the angle value.
     * @param {NodeModel} node - provide the angle value.
     * @private
     */
    layoutAnimation(objValue, layoutTimer, stop, diagram, node) {
        if (!stop) {
            for (let k = 0; k < objValue.objects.length; k++) {
                const node = diagram.nameTable[objValue.objects[parseInt(k.toString(), 10)].id];
                node.offsetX += objValue.objects[parseInt(k.toString(), 10)].differenceX / 5;
                node.offsetY += objValue.objects[parseInt(k.toString(), 10)].differenceY / 5;
            }
        }
        if (stop) {
            clearInterval(layoutTimer[0]);
            this.setIntervalObject = [];
            diagram.realActions = diagram.realActions & ~RealAction.AnimationClick;
            diagram.refreshCanvasLayers();
            diagram.protectPropertyChange(true);
            diagram.triggerEvent(DiagramEvent.animationComplete, undefined);
            diagram.organizationalChartModule.isAnimation = false;
            diagram.layout.fixedNode = '';
            diagram.protectPropertyChange(this.protectChange);
            const arg = {
                element: cloneBlazorObject(clone(node)), state: (node.isExpanded) ? true : false
            };
            diagram.triggerEvent(DiagramEvent.expandStateChange, arg);
            if (diagram.lineRoutingModule && diagram.constraints & DiagramConstraints.LineRouting) {
                diagram.resetSegments();
            }
        }
    }
    /**
     *update the node opacity for the node and connector once the layout animation starts \
     *
     * @returns {  void }    update the node opacity for the node and connector once the layout animation starts .\
     * @param {Node} source - provide the source value.
     * @param {number} value - provide the value.
     * @param {Diagram} diagram - provide the diagram value.
     * @private
     */
    updateOpacity(source, value, diagram) {
        for (let i = 0; i < source.outEdges.length; i++) {
            const connector = diagram.nameTable[source.outEdges[parseInt(i.toString(), 10)]];
            const target = diagram.nameTable[connector.targetID];
            connector.style.opacity = value;
            for (let j = 0; j < connector.wrapper.children.length; j++) {
                connector.wrapper.children[parseInt(j.toString(), 10)].style.opacity = value;
                target.style.opacity = value;
                if (target.wrapper instanceof GroupableView) {
                    diagram.updateNodeProperty(target.wrapper, undefined, value);
                }
            }
            this.updateOpacity(target, value, diagram);
        }
    }
    /**
     *To destroy the ruler
     *
     * @returns {void} To destroy the ruler
     */
    destroy() {
        /**
         * Destroys the LayoutAnimate module
         */
    }
    /**
     * Core method to return the component name.
     *
     * @returns {string}  Core method to return the component name.
     * @private
     */
    getModuleName() {
        /**
         * Returns the module name
         */
        return 'LayoutAnimate';
    }
}
